import axios from 'axios';

const IDEAL_POSTCODES_API_KEY = 'ak_ml9v8fi8cojdt7gP6R9vx3GJEjmBv';

export const postcodeService = {
  // Resolve a selected address to get full details (including country)
  async resolveAddress(udprn) {
    try {
      console.log('[postcodeService] Resolving address with UDPRN:', udprn);
      const response = await axios.get(
        `https://api.ideal-postcodes.co.uk/v1/udprn/${udprn}`,
        {
          params: {
            api_key: IDEAL_POSTCODES_API_KEY,
          },
          timeout: 10000,
        }
      );
      console.log('[postcodeService] Resolved address:', response.data);
      return response.data;
    } catch (error) {
      console.error('[postcodeService] Error resolving address:', error.message);
      return null;
    }
  },

  async searchAddresses(query, limit = 10) {
    try {
      if (!query || query.trim().length < 2) {
        throw new Error('Query must be at least 2 characters');
      }

      const cleanQuery = query.trim();
      console.log('[postcodeService] Starting search for:', cleanQuery);

      // Try postcode search first
      try {
        console.log('[postcodeService] Attempting postcode autocomplete API...');
        const postcodeUrl = `https://api.ideal-postcodes.co.uk/v1/autocomplete/postcode`;
        
        const response = await axios.get(postcodeUrl, {
          params: {
            query: cleanQuery,
            api_key: IDEAL_POSTCODES_API_KEY,
            limit: limit,
          },
          timeout: 10000,
        });
        
        console.log('[postcodeService] Postcode search successful:', response.data);
        return response.data;
      } catch (postcodeError) {
        // Fallback to address search
        console.warn('[postcodeService] Postcode search failed:', postcodeError.message);
        console.log('[postcodeService] Attempting address autocomplete API...');
        
        try {
          const addressUrl = `https://api.ideal-postcodes.co.uk/v1/autocomplete/addresses`;
          
          const response = await axios.get(addressUrl, {
            params: {
              query: cleanQuery,
              api_key: IDEAL_POSTCODES_API_KEY,
              limit: limit,
            },
            timeout: 10000,
          });
          
          console.log('[postcodeService] Address search successful:', response.data);
          return response.data;
        } catch (addressError) {
          console.error('[postcodeService] Address search also failed:', addressError.message);
          
          // Log CORS details if available
          if (addressError.response) {
            console.error('[postcodeService] Response status:', addressError.response.status);
            console.error('[postcodeService] Response data:', addressError.response.data);
          }
          
          if (addressError.code === 'ECONNABORTED') {
            throw new Error('Request timeout - API took too long to respond');
          }
          
          if (addressError.message.includes('CORS') || addressError.message.includes('blocked')) {
            console.error('[postcodeService] CORS Error detected - browser is blocking cross-origin request');
            console.error('[postcodeService] This is expected in browser. Will trigger manual entry fallback.');
          }
          
          throw addressError;
        }
      }
    } catch (error) {
      console.error('[postcodeService] Fatal error:', error.message);
      console.error('[postcodeService] Error type:', error.name);
      console.error('[postcodeService] Full error object:', error);
      throw error;
    }
  },
};
